import { Box, Tab, Tabs, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Components
import Header from '../../../Components/Header/Header';
import OnfleetOrder from './OnfleetOrder';
import ManualOrder from './ManualOrder';
// Context
import { getAccessByModuleName } from '../../../Routes/Routes';
import { AppContext } from '../../../Context/AppContext';
import { MODULES } from '../../../Helpers/Constants';

const Orders = () => {
  const { showToastMessage, modules } = useContext(AppContext);
  const navigate = useNavigate();

  const [access, setAccess] = useState({});

  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);

  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.ONFLEET);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        'You are not authorized to access.',
        'error',
        false
      );
      navigate(`/users`); 
    }
  }

  // Handle Tab Button Click
  const [tabId, setTabId] = React.useState(0);
  const handleTabChange = (event, newTabId) => {
    setTabId(newTabId);
  };

  const handleManageHeaderClick = async (event) => {
    event.preventDefault();
    window.open('https://onfleet.com/dashboard', '_blank');
  };

  return (
    <React.Fragment>
      <Header
        title="Onfleet"
        hasOnfleetOrderButton={true}
        handleOnfleetOrderClick={handleManageHeaderClick}
      />

      <div id="MainContent" className="main-content">
        <div className="container-fluid order-container">
          <Tabs value={tabId} onChange={handleTabChange} className="mb-4">
            <Tab key={0} id={0} label={`Onfleet Order`} />
            <Tab key={1} id={1} label={`Manual Order`} />
          </Tabs>

          <TabPanel tabId={tabId} index={0}>
            <OnfleetOrder />
          </TabPanel>

          <TabPanel tabId={tabId} index={1}>
            <ManualOrder />
          </TabPanel>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Orders;

function TabPanel(props) {
  const { children, tabId, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={tabId !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {tabId === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
